import type { Language } from "@app/constants";

interface Messages {
	amount: string;
	currencyPrefix: string;
	defaultPercent: string;
	defaultValue: string;
	defaultValueMobile: string;
	groupSeparator: string;
	header: string;
	netProfit: string;
	netReturn: string;
	noResults: string;
	viewAll: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		amount: "Amount",
		currencyPrefix: "R ",
		defaultPercent: "0%",
		defaultValue: "R 0",
		defaultValueMobile: "R 0",
		groupSeparator: ",",
		header: "Trade History",
		netProfit: "Net Profit",
		netReturn: "Net Return",
		noResults: "No trade data to display",
		viewAll: "View all",
	},
};

export default messages;
